import {type} from '@ngrx/signals';
import {event} from '@ngrx/signals/events';
import {IdentityProjection} from '@scalified-monorepo/shared/domain';

const areaName = 'auth.debug';

/**
 * Debug-only action that directly sets identity state in the NgRx store
 * WITHOUT triggering any auth side-effects (no token refresh, no logout redirect,
 * no GetIdentity call).
 *
 * Use this in development to isolate state mutations from effect chains, allowing
 * you to observe how the SSE service and UI react to identity changes independently
 * of the normal auth flow.
 *
 * NOTE: SseEffects.handleSseEvents$ subscribes to selectIdentity, so SSE will still
 * react (disconnect on null, reconnect on valid identity) — only NgRx effects are bypassed.
 */
export const SetIdentityDirect = event(
  `[${areaName}] Set Identity Direct`,
  type<{identity: IdentityProjection | null}>()
);
